  /*============================================================================
    Buy Button Snipet - Featured products
    *
    *This displays a collection of products by getting the ID of that collection from the ID of its <div>
  ==============================================================================*/
/*
// NEW FEATURE

$(document).ready(function(){
  
  var productContainer = $('.featured-product');
  var productsContainer = $('.featured-products');

  //removes the class 'mobile' from the other producs that were left from the first version
  if (typeof(productContainer) != 'undefined' && productContainer != null){
      productContainer.each(function(){
          if($(this).hasClass('mobile')){
              $(this).removeClass('mobile');
          }
      });
  }

  // Here you add/change the products
  var featuredProducts_CBD = [
          2385288167509, // The first product will be the only product that will be showed on mobile
          2385288101973,
          2385288003669
  ];

  var featuredProducts_Creams = [
          2559389630549, // The first product will be the only product that will be showed on mobile
          2559389663317,
          2559389696085
  ];

  var featuredProducts_Pets = [
          2385288396885, // The first product will be the only product that will be showed on mobile
          2385288429653,
          2560708575317
  ];
  
  var featuredProducts_Hemp = [
          1618900385862, // The first product will be the only product that will be showed on mobile
          1618879479878,
          1618560745542
  ];

  // Here you need to add another case if you ever add more categories
  // You need to add this exemple after the line 3959 , more exactly after this "switch(productsContainer.attr('id')) {"
  // Here is the exemple:
  //  case LOCATION:
  // 		renderProducts(PRODUCT ARRAY);
  // 		break;
  // 
  // LOCATION - should be the ID of the container
  // PRODUCT ARRAY - should be the name of the array from above, that contains the product IDs

  if (typeof(productsContainer) != 'undefined' && productsContainer != null){
		productsContainer.each(function(i, obj){
          
//           	console.log($(this).attr('id'));
//             console.log(i,obj);
			switch($(this).attr('id')) {
              case "featured-CBD": 
                  renderProducts(featuredProducts_CBD, $(this));
                  break;
              case "featured-Creams":
                  renderProducts(featuredProducts_Creams, $(this));
                  break;
              case "featured-Pets":
                  renderProducts(featuredProducts_Pets, $(this));
                  break;
              case "featured-Hemp": 
                  renderProducts(featuredProducts_Hemp, $(this));
                  break;
              default:
                  renderProducts(featuredProducts_CBD, $(this));
	    	}
		});
  }else{
    console.log('This container is empty: ' + featuredProducts);
  }

  //renders the container for each product containted in featuredProducts
  function renderProducts (featuredProducts, productsContainer){
      if ( featuredProducts.length > 0  ){
          for (var i = 0; i < featuredProducts.length; i++) {
              $('<div>').addClass('featured-product' + (i == 0 ? " mobile" : "")).attr('id', featuredProducts[i]).appendTo(productsContainer);
          }
      }else{
          console.log('This array is empty: ' + featuredProducts);
      }
  }
	
});


$(document).ready(function(){
  
  var productContainer = $('.featured-product');
  
  if (typeof(productContainer) != 'undefined' && productContainer != null){

    productContainer.each(function(){

      var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
      var productNode  = $(this)[0];
      var productID =  $(this).attr('id');

//       console.log(productNode);
//       console.log(productID);
      
      if (window.ShopifyBuy) {
        if (window.ShopifyBuy.UI) {
          ShopifyBuyInit();
        } else {
          loadScript();
        }
      } else {
        loadScript();
      }

      function loadScript() {
        var script = document.createElement('script');
        script.async = true;
        script.src = scriptURL;
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
        script.onload = ShopifyBuyInit;
      }

      function ShopifyBuyInit() {

        var client = ShopifyBuy.buildClient({
          domain: 'formula-swiss-ag-eu.myshopify.com', // VERIFICA ASTA
          storefrontAccessToken: '01c066373aa5ef8c6593e105f98ba472', // VERIFICA ASTA
        });

        ShopifyBuy.UI.onReady(client).then(function (ui) {

          ui.createComponent('product', {
            id: productID,
            node: productNode,
            moneyFormat: '%E2%82%AC%7B%7Bamount%7D%7D', // VERIFICA ASTA
            options: {
              "product": {
                "variantId": "all",
                "contents": {
                  "imgWithCarousel": false,
                  "variantTitle": false,
                  "description": false,
                  "buttonWithQuantity": false,
                  "quantity": false
                },
                 "text": {
					"button": "Adicionar ao Carrinho"
				  },
                "styles": {
                  "product": {
                    "@media (min-width: 601px)": {
                      "max-width": "calc(25% - 20px)",
                      "margin-left": "20px",
                      "margin-bottom": "50px"
                    }
                  }
                }
              },
              "cart": {
                "contents": {
                  "button": true
                },
                 text: {
                    title: "Carrinho de Compras",
                    total: "Subtotal",
                    notice:
                      "Shipping and discount codes are added at checkout.",
                    button: "Finalizar a Compra",
                    empty: "Your shopping basket is empty."
                  },
                "styles": {
                  "footer": {
                    "background-color": "#ffffff"
                  }
                }
              },
              "modalProduct": {
                "contents": {
                  "img": false,
                  "imgWithCarousel": true,
                  "variantTitle": false,
                  "buttonWithQuantity": true,
                  "button": false,
                  "quantity": false
                },
                "styles": {
                  "product": {
                    "@media (min-width: 601px)": {
                      "max-width": "100%",
                      "margin-left": "0px",
                      "margin-bottom": "0px"
                    }
                  }
                }
              },
              "productSet": {
                "styles": {
                  "products": {
                    "@media (min-width: 601px)": {
                      "margin-left": "-20px"
                    }
                  }
                }
              }
            }
          });
        });
      }
    });
  }
});

// $(document).ready(function() {
//   var $summary = $('.new-summary');
  
//   if(typeof($summary) != 'undefined' && $summary != null){
// 	$summary.each(function(){
      
//       // if the content its wrap in a div it will unwrap it
//       var textWrapper = $(this).find('.et_pb_text_inner');
//       if(typeof(textWrapper) != 'undefined' && textWrapper != null){
//       	textWrapper.contents().unwrap();
//       }
      
//       // removes all the content except the p and a tags
//       $(this).find('*').not('p, a').remove();
      
      
//       // gets the first 3 <p>'s from the parent
//       var firstThreeelements = $(this).find('p:lt(3), p:lt(3) *');
//       var extractedSummary = "";
      
//       // concatenate them in extractedSummary & removes them
//       firstThreeelements.each(function(){
//         extractedSummary += $(this).text() + " ";
//         $(this).remove();
//       });
      
//       // clears the parent
//       $(this).empty();
      
//       // appends the extractedSummary to the ".new-summary"
//       $("<p>" + extractedSummary + "</p>").appendTo($(this));
      
//     });
//   }
// });
*/

// COUNTRY DROPDOWN, this will add new elements to the list
$(document).ready(function(){

  var $container = $('.dropdown-country-custom, .dropdown-country-custom-mobile');
  
  // EDIT HERE TO CHANGE THE DEFAULT COUNTRY:
  var default_flag_img = 'https://cdn.shopify.com/s/files/1/0014/5378/5158/files/portugal-flag-icon-32.jpg?v=1600868702';
  var default_flag_txt = 'Portugal';
  
  // EDIT HERE FOR ADDING MORE COUNTRIES:
  var markup = '';
 
markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/bulgaria-flag-icon-32.jpg?v=1600869203" alt="BG flag" class="lazyload dropdown-country-flag"><a href="https://bg.formulaswiss.com">България</a></li>'; 
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/czech-republic-flag-icon-32.jpg?v=1600867996" alt="CZ flag" class="lazyload dropdown-country-flag"><a href="https://cz.formulaswiss.com">Česká Republika</a></li>'; 
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/denmark-flag-icon-32.jpg?v=1600869174" alt="DK flag" class="lazyload dropdown-country-flag"><a href="https://dk.formulaswiss.com">Danmark</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/germany-flag-icon-32.jpg?v=1600868178" alt="DE flag" class="lazyload dropdown-country-flag"><a href="https://de.formulaswiss.com">Deutschland</a></li>'; 
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/spain-flag-icon-32.jpg?v=1600868305" alt="ES flag" class="lazyload dropdown-country-flag"><a href="https://es.formulaswiss.com">España</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/france-flag-icon-32.jpg?v=1600868360" alt="FR flag" class="lazyload dropdown-country-flag"><a href="https://fr.formulaswiss.com">France</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/Global-Network-icon.jpg?v=1601626720" alt="Int" class="lazyload dropdown-country-flag"><a href="https://formulaswiss.com">International</a></li>'; 
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/italy-flag-icon-32.jpg?v=1600868515" alt="IT flag" class="lazyload dropdown-country-flag"><a href="https://it.formulaswiss.com">Italia</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/netherlands-flag-icon-32.jpg?v=1600868609" alt="NL flag" class="lazyload dropdown-country-flag"><a href="https://nl.formulaswiss.com">Nederland</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/norway-flag-icon-32.jpg?v=1600868636" alt="NO flag" class="lazyload dropdown-country-flag"><a href="https://no.formulaswiss.com">Norge</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/austria-flag-icon-32.jpg?v=1600868797" alt="AT flag" class="lazyload dropdown-country-flag"><a href="https://at.formulaswiss.com">Österreich</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/poland-flag-icon-32.jpg?v=1600868737" alt="PL flag" class="lazyload dropdown-country-flag"><a href="https://pl.formulaswiss.com">Polska</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/portugal-flag-icon-32.jpg?v=1600868702" alt="PT flag" class="lazyload dropdown-country-flag"><a href="https://pt.formulaswiss.com">Portugal</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/romania-flag-icon-32.jpg?v=1600868863" alt="RO flag" class="lazyload dropdown-country-flag lazyload"><a href="https://ro.formulaswiss.com">Romania</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/switzerland-flag-icon-32.jpg?v=1600868917" alt="CH flag" class="lazyload dropdown-country-flag"><a href="https://ch.formulaswiss.com">Schweiz</a></li>';
//   markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/switzerland-flag-icon-32.jpg?v=1600868917" alt="CH flag" class="lazyload dropdown-country-flag lazyload"><a href="https://suisse.formulaswiss.com">Suisse</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/finland-flag-icon-32.jpg?v=1600869035" alt="FI flag" class="lazyload dropdown-country-flag"><a href="https://fi.formulaswiss.com">Suomi</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/sweden-flag-icon-32.jpg?v=1600869080" alt="SE flag" class="lazyload dropdown-country-flag"><a href="https://se.formulaswiss.com">Sverige</a></li>';
//   markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/switzerland-flag-icon-32.jpg?v=1600868917" alt="CH flag" class="lazyload dropdown-country-flag"><a href="https://svizzera.formulaswiss.com">Svizzera</a></li>';
  markup += '<li><img data-src="https://cdn.shopify.com/s/files/1/0014/5378/5158/files/united-kingdom-flag-icon-32.jpg?v=1600869145" alt="UK flag" class="lazyload dropdown-country-flag"><a href="https://uk.formulaswiss.com">United Kingdom</a></li>';
  
  if(typeof($container) != 'undefined' && $container != null){
    $('.default-country-flag').attr('src', default_flag_img);
    $('.default-country-flag-text').text(default_flag_txt).append('<span class="icon-down-arrow"></span>');
    $container.append(markup);
  }
  
});
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}